import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div.attrs({
  "data-testid": "patient-shell",
} as Record<string, string>)`
  flex: 1 1 auto;
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr);
  min-height: 0;
  height: 100%;
  overflow: hidden;
  padding: 12px 32px 0;
  background-color: #f8f8f8;
`;

export const Layout = styled.div.attrs({
  "data-testid": "patient-layout",
} as Record<string, string>)`
  display: grid;
  grid-template-columns: 256px minmax(0, 1fr);
  gap: 24px;
  margin-top: 20px;
  min-height: 0;
  overflow: hidden;
  align-items: stretch;
  padding-bottom: 12px;
`;

export const MainMenu = styled.div.attrs({
  "data-testid": "patient-main-nav",
} as Record<string, string>)`
  display: flex;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 8px;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
`;

export const Content = styled.div.attrs({
  "data-testid": "content-section",
} as Record<string, string>)<{ $isStretchContent?: boolean }>`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  background-color: white;
  border-radius: 8px;
  padding: 32px;
  flex: 1 1 0%;
  min-height: 0;
  min-width: 0;
  overflow: ${({ $isStretchContent }) =>
    $isStretchContent ? "hidden" : "auto"};
`;

interface OuterWrapperProps {
  $themeColor?: string;
}

export const Link = styled(NavLink)<OuterWrapperProps>`
  text-decoration: none;
  border-radius: 4px;
  margin: 0 0 2px 0;
  padding: 5px 8px;

  &.active {
    background: #ebf4ff;

    & span {
      color: #065fa6;
    }
  }

  &:hover {
    background: #ebf4ff;

    & span {
      color: #065fa6;
    }
  }

  & span {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #181818;
    padding-left: 12px;

    &:hover {
      color: "#065FA6";
    }
  }

  & svg {
    position: relative;
    top: 4px;
  }
`;

export const DisabledLink = styled.div<OuterWrapperProps>`
  text-decoration: none;
  border-radius: 4px;
  margin: 0 0 2px 0;
  padding: 5px 8px;
  cursor: pointer;

  &:hover {
    background: #ebf4ff;

    & span {
      color: #065fa6;
    }
  }

  & span {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #181818;
    padding-left: 12px;
  }

  & svg {
    position: relative;
    top: 4px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #e7e7e7;
  width: 100%;
  margin: 10px 0;
`;

export const Breadcrumbs = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: #181818;
`;

export const PatientContext = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
`;

export const PatientContextControls = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  justify-content: space-between;
`;

export const PatientDetails = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
`;

export const PatientName = styled.div`
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
`;

export const PatientData = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  color: #181818;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
`;

export const PatientControlItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  color: #181818;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  cursor: pointer;
`;
